<button mat-raised-button *appRole="['Icl.Calcular']" color="primary" #tooltip="matTooltip" matTooltip="Generación de calculos ICL." class="btn-nuevo" (click)="openDialogNuevoCalculoIcl()">
    <mat-icon>change_circle </mat-icon> Generar calculos ICL
</button>
